
const todaydate = {
    state: {
        todaydate: '',
        notice:false,
        SystemType:"",
        type:"",

        
    },
    mutations: {
        SET_TODAYDATE: (state,v) => {
            state.todaydate = v
        },
        SET_NOTICE: (state,v) => {
            state.notice = v
        },
        SET_SYSTEMTYPE: (state,v) => {
            state.SystemType = v
        },
        SET_TYPE: (state,v) => {
            state.type = v
        }
    },

    actions: {
        SET_TODAYDATE(context,v){
            context.commit("SET_TODAYDATE",v);
        },
        SET_NOTICE(context,v){
            context.commit("SET_NOTICE",v);
        },
        SET_SYSTEMTYPE(context,v){
            context.commit("SET_SYSTEMTYPE",v);
        },
        SET_TYPE(context,v){
            context.commit("SET_TYPE",v);
        }
        
    }
}

export default todaydate
